/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Best_Value_LabelInputs */

const en_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save ~17%`)
};

const id_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemat ~17%`)
};

const ms_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jimat ~17%`)
};

const ca_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estalvia ~17%`)
};

const cs_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ušetřete ~17 %`)
};

const da_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spar ~17 %`)
};

const de_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparen Sie rund 17 %`)
};

const et_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästa ~17%`)
};

const es_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra ~17 %`)
};

const fr_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Économisez environ 17 %`)
};

const hr_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uštedite ~17%`)
};

const it_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmia il ~17%`)
};

const lv_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ietaupiet ~17%`)
};

const lt_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sutaupykite ~17 %`)
};

const hu_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spórolj ~17%-ot`)
};

const nl_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespaar ~17%`)
};

const nb_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spar ~17 %`)
};

const pl_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oszczędź ~17%`)
};

const pt_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economize 17%`)
};

const ro_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economisește ~17%`)
};

const sk_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ušetrite ~17 %`)
};

const sl_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prihranite ~17 %`)
};

const fi_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästä ~17 %`)
};

const sv_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara ~17 %`)
};

const vi_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiết kiệm ~17%`)
};

const tr_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~%17 tasarruf edin`)
};

const el_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξοικονομήστε ~17%`)
};

const bg_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спестете ~17%`)
};

const ru_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экономия ~17%`)
};

const sr_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уштедите ~17%`)
};

const uk_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Економія ~17%`)
};

const ka_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაზოგეთ ~17%`)
};

const hi_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~17% बचाएं`)
};

const th_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประหยัด ~17%`)
};

const ko_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 17% 절약`)
};

const zh_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 2 个月`)
};

const zh_tw_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`節省約 17%`)
};

const ja_best_value_label = /** @type {(inputs: Best_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`約17%お得`)
};

/**
* | output |
* | --- |
* | "Save ~17%" |
*
* @param {Best_Value_LabelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const best_value_label = /** @type {((inputs?: Best_Value_LabelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Best_Value_LabelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_best_value_label(inputs)
	if (locale === "ms") return ms_best_value_label(inputs)
	if (locale === "ca") return ca_best_value_label(inputs)
	if (locale === "cs") return cs_best_value_label(inputs)
	if (locale === "da") return da_best_value_label(inputs)
	if (locale === "de") return de_best_value_label(inputs)
	if (locale === "et") return et_best_value_label(inputs)
	if (locale === "es") return es_best_value_label(inputs)
	if (locale === "fr") return fr_best_value_label(inputs)
	if (locale === "hr") return hr_best_value_label(inputs)
	if (locale === "it") return it_best_value_label(inputs)
	if (locale === "lv") return lv_best_value_label(inputs)
	if (locale === "lt") return lt_best_value_label(inputs)
	if (locale === "hu") return hu_best_value_label(inputs)
	if (locale === "nl") return nl_best_value_label(inputs)
	if (locale === "nb") return nb_best_value_label(inputs)
	if (locale === "pl") return pl_best_value_label(inputs)
	if (locale === "pt") return pt_best_value_label(inputs)
	if (locale === "ro") return ro_best_value_label(inputs)
	if (locale === "sk") return sk_best_value_label(inputs)
	if (locale === "sl") return sl_best_value_label(inputs)
	if (locale === "fi") return fi_best_value_label(inputs)
	if (locale === "sv") return sv_best_value_label(inputs)
	if (locale === "vi") return vi_best_value_label(inputs)
	if (locale === "tr") return tr_best_value_label(inputs)
	if (locale === "el") return el_best_value_label(inputs)
	if (locale === "bg") return bg_best_value_label(inputs)
	if (locale === "ru") return ru_best_value_label(inputs)
	if (locale === "sr") return sr_best_value_label(inputs)
	if (locale === "uk") return uk_best_value_label(inputs)
	if (locale === "ka") return ka_best_value_label(inputs)
	if (locale === "hi") return hi_best_value_label(inputs)
	if (locale === "th") return th_best_value_label(inputs)
	if (locale === "ko") return ko_best_value_label(inputs)
	if (locale === "zh") return zh_best_value_label(inputs)
	if (locale === "zh-tw") return zh_tw_best_value_label(inputs)
	if (locale === "ja") return ja_best_value_label(inputs)
	return en_best_value_label(inputs)
});